import { z } from "zod";

export const contactTopics = [
  "Inženýring",
  "Potrubní systémy",
  "Laserové skenování",
  "Pevnostní výpočty",
  "Hydraulické výpočty",
  "Jiné",
] as const;

/**
 * Server-side kontrakt formuláře. Statický export nepodporuje Route Handlers
 * s metodou POST, odesílání proto zajišťuje PHP proxy `api/abuilder.php`
 * (součást statického ZIPu pro PHP hosting). Schema je zde proto sdílené
 * jako jediný zdroj pravdy pro klientskou validaci i pro kontrakt polí,
 * která proxy přijímá.
 */
export const contactSchema = z.object({
  name: z
    .string()
    .min(2, "Zadejte prosím jméno a příjmení.")
    .max(80, "Jméno je příliš dlouhé."),
  company: z.string().max(120, "Název je příliš dlouhý.").optional(),
  email: z.email("Zadejte platnou e-mailovou adresu."),
  phone: z.string().max(40, "Telefon je příliš dlouhý.").optional(),
  topic: z.string().max(80).optional(),
  message: z
    .string()
    .min(10, "Popište prosím poptávku alespoň deseti znaky.")
    .max(4000, "Zpráva je příliš dlouhá."),
  consent: z.boolean().refine((value) => value, {
    message: "Bez souhlasu se zpracováním údajů nemůžeme poptávku odeslat.",
  }),
});

export type ContactInput = z.infer<typeof contactSchema>;

export const contactFormSchema = contactSchema.extend({
  website: z.string().optional(),
});

export type ContactFormInput = z.infer<typeof contactFormSchema>;

/** Adresa PHP proxy ve statickém exportu (relativně kvůli hostingu v podadresáři). */
export const contactEndpoint = "api/abuilder.php";
